<template>
    <div class="p-1">
        <h1 class="text-xs text-center w-full font-bold">应用权限说明</h1>
        <h2 class="text-justify font-bold mb-2">在您的使用我方客户端功能服务的过程中，体验功能需要调用客户端或SDK时，将会调用如下设备权限，以保障正常的功能实现。为了您更好的理解与使用我们的功能服务，您可以通过下方列举的权限使用说明进行了解：</h2>
        <table class="border"  >
            <tr class="border">
                <th class="border py-1.5">权限名称</th>
                <th class="border py-1.5">权限功能说明</th>
                <th class="border py-1.5">使用场景或目的</th>
            </tr>
            <tr class="border" v-for="(i,index) in data" :key="index">
                <td class="border py-1.5" v-html="i.name"></td>
                <td class="border px-0.5 py-1.5" v-html="i.desc"></td>
                <td class="border px-0.5 py-1.5" v-html="i.scene"></td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    data(){
        return {
            data:[
                {name:"android.permission.<br/>GET_TASKS"	,desc:"获取当前或最近运行的任务"	,scene:"该权限用于闪验SDK进行数据切换；<br>小米SDK的消息推送服务"},
                {name:"android.permission.<br/>WRITE_SETTINGS"	,desc:"允许更改手机设置"	,scene:"该权限用于闪验SDK增加电信号<br>在wifi+移动数据下取号成功几率"},
                {name:"android.permission.<br/>READ_PHONE_STATE"	,desc:"获取手机状态"	,scene:"该权限用于闪验SDK；<br>获取IMSI用于判断双卡和换卡"},
                {name:"android.permission.<br/>ACCESS_WIFI_STATE"	,desc:"获取wifi状态"	,scene:"该权限用于基础的连接网络功能"},
                {name:"android.permission.<br/>CHANGE_WIFI_STATE"	,desc:"改变wifi状态"	,scene:"该权限用于闪验SDK在<br>临时在取号时切换到移动数据"},
                {name:"android.permission.<br/>INTERNET"	,desc:"访问网络"	,scene:"该权限用于基础的连接网络功能"},
                {name:"android.permission.<br/>WRITE_EXTERNAL_STORAGE"	,desc:"写入文件"	,scene:"该权限用于读取音频文件、记录睡眠文件"},
                {name:"android.permission.<br/>READ_EXTERNAL_STORAGE"	,desc:"读取文件"	,scene:"该权限用于存放音频文件、记录睡眠文件"},
                {name:"android.permission.<br/>CAMERA"	,desc:"照相机"	,scene:"该权限用于小实验功能<br>提供分析心率变化服务；<br>通过拍照的方式更新个人头像"},
                {name:"com.android.alarm.permission.<br/>SET_ALARM"	,desc:"设置闹钟"	,scene:"该权限用于记录睡眠功能设置唤醒闹铃"},
                {name:"android.permission.<br/>REQUEST_IGNORE_BATTERY_OPTIMIZATIONS"	,desc:"加入电池优化白名单"	,scene:"该权限用于保障心潮后台运行稳定性"},
                {name:"android.permission.<br/>MODIFY_AUDIO_SETTINGS"	,desc:"更改声音设定"	,scene:"该权限用于心潮无痛唤醒闹铃功能"},
                {name:"android.permission.<br/>ACCESS_FINE_LOCATION"	,desc:"获取精确定位"	,scene:"该权限用于友盟统计SDK的数据分析服务"},
                {name:"android.permission.<br/>ACCESS_COARSE_LOCATION"	,desc:"获取粗略定位"	,scene:"该权限用于友盟统计SDK的数据分析服务"},
                {name:"android.permission.<br/>VIBRATE"	,desc:"手机振动"	,scene:"该权限用于记录睡眠功<br>能提醒用户进入睡眠状态"},
                {name:"com.android.launcher.permission.<br/>INSTALL_SHORTCUT"	,desc:"添加快捷方式"	,scene:"该权限用于无痛唤醒闹钟<br>功能添加快捷方式"},
                {name:"android.permission.<br/>WAKE_LOCK"	,desc:"唤醒锁"	,scene:"该权限用于保障记录睡眠服务进程存活"},
                {name:"android.permission.<br/>DEVICE_POWER"	,desc:"手机电源管理"	,scene:"该权限用于保障记录睡眠服务进程存活"},
                {name:"android.permission.<br/>REQUEST_INSTALL_PACKAGES"	,desc:"安装App"	,scene:"该权限用于提供App版本更新功能"},
                {name:"android.permission.<br/>FOREGROUND_SERVICE"	,desc:"建立前台服务"	,scene:"该权限用于音频服务、<br>闹钟服务、记录睡眠"},
                {name:"android.permission.<br/>RECORD_AUDIO"	,desc:"录音权限"	,scene:"该权限用于宁静空间功能和记录睡眠，<br>运行环境噪音分析算法"},
                {name:"com.coloros.mcs.permission.<br/>RECIEVE_MCS_MESSAGE"	,desc:"推送通知"	,scene:"该权限用于推送通知服务"},
                {name:"com.psyone.brainmusic.permission.<br/>receiver"	,desc:"推送通知"	,scene:"该权限用于推送通知服务"},
                {name:"com.psyone.brainmusic.permission.<br/>MIPUSH_RECEIVE"	,desc:"推送通知"	,scene:"该权限用于小米推送通知服务"},
                {name:"com.heytap.mcs.permission.<br/>RECIEVE_MCS_MESSAGE"	,desc:"推送通知"	,scene:"该权限用于推送通知服务"},
                {name:"com.meizu.flyme.push.permission.<br/>RECEIVE"	,desc:"推送通知"	,scene:"该权限用于魅族推送通知服务"},
                {name:"com.psyone.brainmusic.push.permission.<br/>MESSAGE"	,desc:"推送通知"	,scene:"该权限用于推送通知服务"},
                {name:"com.meizu.c2dm.permission.<br/>RECEIVE"	,desc:"推送通知"	,scene:"该权限用于魅族推送通知服务"},
                {name:"com.psyone.brainmusic.permission.<br/>C2D_MESSAGE"	,desc:"推送通知"	,scene:"该权限用于推送通知服务"},
                {name:"android.hardware.camera"	,desc:"照相机"	,scene:"该权限用于小实验功能<br>提供分析心率变化服务；<br>通过拍照的方式更新个人头像。"},
                {name:"android.hardware.camera.autofocus"	,desc:"照相机自动对焦功能"	,scene:"该权限用于过拍照的方式更新个人头像"},
                {name:"android.permission.<br/>SYSTEM_ALERT_WINDOW"	,desc:"应用顶层浮窗"	,scene:"该权限用于提供记录睡眠的浮窗功能"},
                {name:"com.heytap.wearable.oms.permission.<br/>TRACSPORT"	,desc:"OPPO手表"	,scene:"该权限用于设备连接OPPO手表"},
                {name:"android.permission.<br/>MOUNT_UNMOUNT_FILESYSTEMS"	,desc:"允许挂载和反挂载<br>文件系统可移动存储"	,scene:"该权限用于SD卡读写功能"},
                {name:"android.permission.<br/>READ_LOGS"	,desc:"读取日志"	,scene:"该权限用于采集日志信息以排查问题"},
                {name:"android.permission.<br/>RECEIVE_BOOT_COMPLETED"	,desc:"自启动或关联启动"	,scene:"该权限用于实现闹钟唤醒功能"},

            ]
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{

    },
}
</script>

<style lang='scss' scoped>
h2{
    font-size: px2html(16px);
}


.box{
    
    p{
        text-align: left;
        margin-bottom: px2html(5px);
        &:first-child{
            font-weight: bolder;
            font-size: px2html(16px);
        }
        span{
            font-weight: bold;
        }
        a{
            color: rgb(8,124,255);
            text-decoration: underline;
        }
    }

}
</style>